import { shoeConventionForSite } from "@config/site/site-config";
import { SizeLocales } from "@lib/constants/filtersConstants";
import type { StoreDataType } from "./types";

export const initialState: StoreDataType = {
    isLocked: false,
    isPreviewMode: false,
    hasFreshData: false,
    me: {
        customer: undefined,
        globalShoeSizeConvention: shoeConventionForSite?.[0] ?? SizeLocales.EU,
        cartInfo: {
            cart: undefined,
            masterProducts: undefined,
            shippingMethods: undefined,
            isExecuted: true,
        },
        wishlistInfo: { wishlist: undefined, masterProducts: undefined, isExecuted: true },
    },
    tracking: {
        utm: {
            source: "",
            medium: "",
            campaign: "",
            term: "",
            content: "",
        },
    },
    stores: [],
    draftPromoCode: undefined,
    products: {
        list: [],
        currentFilters: [],
        resultsCount: null,
        initialFilters: {},
        lastVisitedPlp: null,
        lastLoadedPage: 1,
        lastVisitedPlpContainerHeight: 0,
    },
    pdpState: {
        activeProduct: null,
        isOpenAddedToBagModal: false,
    },
    storeData: undefined,
    parcelShopData: undefined,
    policyAccepted: false,
    tempCustomerData: {
        firstName: null,
        lastName: null,
        email: null,
    },
    productImageGallery: {
        isGalleryOpen: false,
        galleryImageIndex: 0,
    },
    hasActiveTimer: false,
};
